module.exports = __webpack_public_path__ + "static/media/OSS.91f9a1ea.pdf";